import { ApiService, IJsonObject } from "../api";

/**
 * Functions for fetching statistics.
 */
export class StatsService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findSalesStats(date: Date): Promise<IJsonObject> {
		return this.getStats("sales", { date: date.toJSON() });
	}

	public async findSalesStatsByRep(date: Date): Promise<IJsonObject> {
		return this.getStats("sales-by-rep", { date: date.toJSON() });
	}

	public async findCaSubscribers(date: Date): Promise<IJsonObject> {
		return this.getStats("ca-subscribers", { date: date.toJSON() });
	}

	public async findUserStats(date: Date): Promise<IJsonObject> {
		return this.getStats("user", { date: date.toJSON() });
	}

	public async findUserTripTrackerStats(): Promise<IJsonObject> {
		return this.getStats("trip-tracker");
	}

	public async findPipelineFunnel(date?: Date, userId?: number): Promise<IJsonObject> {
		const params: { date?: string; user_id?: number } = {};
		if (date) {
			params.date = date.toJSON();
		}
		if (userId) {
			params.user_id = userId;
		}
		return this.getStats("pipeline-funnel", params);
	}

	public async findConversionReport(date: Date, userId?: number, months?: number): Promise<IJsonObject> {
		const params: { date: string; user_id?: number; months?: number } = { date: date.toJSON() };
		if (userId) {
			params.user_id = userId;
		}
		if (months) {
			params.months = months;
		}
		return this.getStats("conversion-report", params);
	}

	public async findSalesCycle(date: Date, userId?: number): Promise<IJsonObject> {
		const params: { date: string; user_id?: number } = { date: date.toJSON() };
		if (userId) {
			params.user_id = userId;
		}
		return this.getStats("sales-cycle", params);
	}

	private async getStats(
		endpoint: string,
		params?: object,
	): Promise<IJsonObject> {
		const statData = await this.apiService.get(
			`/api/v1/stats/${endpoint}`,
			params,
		);
		const stats = await statData.json();

		return stats;
	}
}
